import { Clock } from '@/modules/working_hours/domain/Clock';
import { ClockRepo } from '@/modules/working_hours/domain/ClockRepo';
import { User } from "@/modules/working_hours/domain/User";

abstract class ClockCommand {
  protected abstract readonly type: 'in' | 'out' | 'pause' | 'continue';

  constructor(
    protected readonly clockRepo: ClockRepo,
    protected readonly screen_data: any,
    protected readonly estado_texto_ms: number,
    protected readonly timer_ms: number,
    protected timer: any
  ) {
  }

  abstract timer_manage(): void;

  async execute(timestamp: Date, uuid: string, location: string = 'office'): Promise<void> {
    this.screen_data.ui_loading = true;

    const last = await this.clockRepo.find_last();

    if(last){
      if (last.type === this.type) {
        this.screen_data.estado_texto = '';
        this.screen_data.ui_loading = false;
        return;
      }
    }
    const user1: User = new User(1,"Juan Pérez","Juan Pérez@example.com",'worker')

    const clock = new Clock(uuid, timestamp, this.type, user1, [], false, location);

    // Guardar en servidor ANTES de actualizar el estado local
    try {
      await this.clockRepo.save(clock);
    } catch (error) {
      console.error('Error guardando fichaje en servidor:', error);
      this.screen_data.ui_loading = false;
      this.screen_data.estado_texto = 'Error al guardar el fichaje. Inténtalo de nuevo.';
      await new Promise(resolve => setTimeout(resolve, this.estado_texto_ms));
      this.screen_data.estado_texto = '';
      throw error;
    }

    // Solo actualizar estado local DESPUÉS de que el save haya sido exitoso
    this.screen_data.last_clock = clock;
    const hoy = new Date();
    const inicioHoy = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());

    if (clock.timestamp >= inicioHoy) {
      this.screen_data.clocks.push(clock);
    }

    console.log('Clock guardado en servidor');
    this.screen_data.ui_loading = false;

    // Solo actualizar ui_hide_btn para 'in' y 'out', no para 'pause' y 'continue'
    if (this.type === 'in' || this.type === 'out') {
      this.screen_data.ui_hide_btn = this.type;
    }

    this.screen_data.estado_texto = 'Fichaje exitoso';
    this.timer_manage()

    await new Promise(resolve => setTimeout(resolve, this.estado_texto_ms));
    this.screen_data.estado_texto = '';

  }
}

export class ClockInCommand extends ClockCommand {
  protected readonly type = 'in';
  timer_manage = () => {
    // Resetear el contador a 0 al fichar entrada
    // El intervalo de WorkingHours.vue mounted() se encarga de incrementar
    this.screen_data.timerCounting = 0;
    this.screen_data.pauseCounting = 0;
  };
}

export class ClockOutCommand extends ClockCommand {
  protected readonly type = 'out';
  timer_manage = () => {
    // Solo pausar el timer, mantener el valor actual del contador
    clearInterval(this.timer.t);
    this.timer.t = null;
  }
}

export class ClockPauseCommand extends ClockCommand {
  protected readonly type = 'pause';
  timer_manage = () => {
  }
}

export class ClockContinueCommand extends ClockCommand {
  protected readonly type = 'continue';
  timer_manage = () => {
  }
}
